import React from 'react';
import { createRoot } from 'react-dom/client';
import ErrorBoundary from '../error-boundary/error-boundary';
import './product-yotpo-reviews.css';
import ProductGallery from './product-gallery';
import ProductForm from './product-form';
import BundleForm from './product-bundle-form';
import SizeGuide from './size-guide';
import CartContext from '../cart/cart-context';
import ProductAccordions from './product-accordions';
import ProductFeatures from './product-features';
import { ProductContext } from './product-context';
import ProductRecommendations from './product-recommendations';

export default (element, data) => {
  const Product = (props) => {
    return (
      <>
        <div className="container items-start justify-center pb-10 md:flex md:gap-10 md:pb-14.5 lg:gap-20 xl:max-w-[120rem]">
          <div className="relative top-0 flex items-start md:sticky md:min-w-0 md:flex-1 xl:max-w-[751px]">
            <ProductGallery {...props} />
          </div>
          <div className="mx-auto flex w-full flex-col gap-y-8 px-3 pt-4 md:mx-0 md:mt-0 md:max-w-[45%] md:p-0 lg:max-w-[27.375rem]">
            {props.isBundle ? <BundleForm {...props} /> : <ProductForm {...props} />}
            <div className="flex flex-col gap-y-3">
              <ProductFeatures {...props} />
              <ProductAccordions {...props} />
              <ProductRecommendations {...props} />
            </div>
          </div>
        </div>
        {props?.product?.showSizeGuide && (
          <SizeGuide
            sizeGuideData={props?.sizeGuide?.data}
            subBrand={props.product?.metafields?.subBrand}
            description={props?.sizeGuide?.description}
            product={props.product}
          />
        )}
      </>
    );
  };

  const init = () => {
    const root = createRoot(element);
    root.render(
      <CartContext data={data}>
        <ProductContext product={data.product}>
          <ErrorBoundary>
            <Product {...data} />
          </ErrorBoundary>
        </ProductContext>
      </CartContext>,
    );
  };

  init();
};
